// Tim Hortons has a special section header,
// This makes sure that we do not actually render a header on other
// brands/platforms
export default function MainMenuSectionHeader() {
  return null;
}
